import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditDefaultVisibilityPayload } from '@app-store/slices/eventSettings/editDefaultVisibility'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: IEditDefaultVisibilityPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.eventSetting.editDefaultVisibility

function* editDefaultVisibilityByIdSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.put(`/event/settings/${payload.settingId}/default-visibility`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Visibility setting updated successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editDefaultVisibilityByIdSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editDefaultVisibilityByIdSagaTask)
}

export default editDefaultVisibilityByIdSaga
